import { v4 as uuidv4 } from "uuid";

function FARM_CREATOR() {
  return {
    id: "",
    name: "",
    owner_id: "",
    province: "",
    fields: [],
    machines: [
      // {
      //   type: "SWATHER",
      //   name: "Swather 1",
      //   HP: 800,
      //   fuelUse: null,
      //   defaultAcreHour: 2,
      // },
      // {
      //   type: "TRACTOR",
      //   name: "My Little Tractor",
      //   HP: 800,
      //   fuelUse: null,
      //   defaultAcreHour: 2,
      // },
      // {
      //   type: "COMBINE",
      //   name: "Combine 1",
      //   HP: 800,
      //   fuelUse: null,
      //   defaultAcreHour: 2,
      // },
      // {
      //   type: "SPRAYER",
      //   name: "Sprayer 1",
      //   HP: 150,
      //   fuelUse: null,
      //   defaultAcreHour: 30,
      // },
    ],
    project_id: "",
    addField() {
      this.fields.push(FIELD_CREATOR());
    },
  };
}

function FIELD_CREATOR() {
  return {
    id: "",
    farm_id: "",
    name: "",
    field_size: "",
    field_address: "",
    surface_form: "",
    slope_class: "",
    soil_type: "",
    surface_soil_texture: "",
    topsoil_horizon_thickness_cm: null,
    tillage_regime: "",
    previous_tillage_regime: "",
    regime_change_date: "",
    ecodistrict: "",
    slc_polygon: "",
    soil_code: "",
    has_boundaries: false,
    boundaries: [],
    field_boundaries_size: 0,
    crop_years: [
      {
        id: "",
        field_id: "",
        crop_year: "",
        crop_this_year: "",
        crop_frequency: "",
        yield_value: "",
        yield_units: "",
        previous_crop: "",
        planting_operation: {
          type: "",
          hours_used: "",
          machine_id: "",
          applied_fertilizer: false,
        },
        cultivations: [],
        fertilizer_applications: [],
        fertilizer_rates: {
          N: {
            pre_seed: "",
            with_seed: "",
            post_seed: "",
          },
          P: {
            pre_seed: "",
            with_seed: "",
            post_seed: "",
          },
          K: {
            pre_seed: "",
            with_seed: "",
            post_seed: "",
          },
          S: {
            pre_seed: "",
            with_seed: "",
            post_seed: "",
          },
          M: {
            pre_seed: "",
            with_seed: "",
            post_seed: "",
          },
        },
        pesticide_applications: [
          {
            machine_id: "",
            hours_used: "",
          },
        ],
        harvest: {
          swather: {
            machine_id: null,
            hours_used: null,
          },
          combine: {
            machine_id: null,
            hours_used: null,
            avg_speed: null,
          },
          crop_drying_type: null,
          crop_drying_fuel: null,
          moisture: {
            before_drying: null,
            after_drying: null,
          },
        },
      },
    ], //"CROPYEAR"
  };
}

function CULTIVATION_OPERATION_CREATOR() {
  return {
    machine_id: "",
    hours_used: "",
    operation_date: "",
    fuel_used_litres: "",
  };
}
function PLANTING_OPERATION_CREATOR() {
  return {
    type: "",
    hours_used: "",
    machine_id: "",
    applied_fertilizer: false,
    operation_date: "",
    fuel_used_litres: "",
  };
}

function FERTILIZER_OPERATION_CREATOR() {
  return {
    machine_id: "",
    hours_used: "",
    application_date: "",
    fuel_used_litres: "",
  };
}

function PESTICIDE_OPERATION_CREATOR() {
  return {
    machine_id: "",
    hours_used: "",
    operation_date: "",
    fuel_used_litres: "",
  };
}

function FERTILIZER_RATE_CREATOR() {
  return { pre_seed: "", with_seed: "", post_seed: "" };
}

function CROPYEAR_CREATOR(fieldId, crop) {
  return {
    id: "",
    field_id: fieldId,
    analysis_id: false,
    crop_year: "",
    crop_this_year: "",
    crop_frequency: "",
    yield_value: "",
    yield_units: "",
    previous_crop: "",
    tillage_regime: "",
    previous_tillage_regime: "",
    regime_change_date: "",
    residue_management: "",
    soil_organic_matter_percent: "",
    soil_organic_matter_date: "",
    is_irrigated: false,
    irrigation_water_applied: "",
    irrigation_water_unit: "mm",
    irrigation_energy_source: "",
    irrigation_energy_used: "",
    irrigation_energy_unit: "",
    cultivations: [
      // CULTIVATION_OPERATION_CREATOR(),
      // CULTIVATION_OPERATION_CREATOR(),
      // CULTIVATION_OPERATION_CREATOR(),
      // CULTIVATION_OPERATION_CREATOR(),
    ],
    planting_operation: PLANTING_OPERATION_CREATOR(),
    fertilizer_applications: [
      // FERTILIZER_OPERATION_CREATOR(),
    ],
    fertilizer_rates: {
      N: FERTILIZER_RATE_CREATOR(),
      P: FERTILIZER_RATE_CREATOR(),
      K: FERTILIZER_RATE_CREATOR(),
      S: FERTILIZER_RATE_CREATOR(),
      M: FERTILIZER_RATE_CREATOR(),
    },
    pesticide_applications: [
      // PESTICIDE_OPERATION_CREATOR(),
      // PESTICIDE_OPERATION_CREATOR(),
      // PESTICIDE_OPERATION_CREATOR(),
      // PESTICIDE_OPERATION_CREATOR(),
      // PESTICIDE_OPERATION_CREATOR(),
    ],
    harvest: {
      swather: {
        machine_id: "",
        hours_used: "",
        operation_date: "",
        fuel_used_litres: "",
      },
      combine: {
        machine_id: "",
        hours_used: "",
        avg_speed: "",
        operation_date: "",
        fuel_used_litres: "",
      },
      crop_drying_type: "",
      crop_drying_fuel: "",
      moisture: {
        before_drying: "",
        after_drying: "",
      },
    },
  };
}

function FOUR_R_FERTILIZER_APPLICATION_CREATOR() {
  return {
    application_date: "", // a date string of the form "DD-MM-YYYY"
    application_method: "", // Can be a string of the following ["Banded","Broadcast"]
    fertilizer_timing: "", // Can take one of the following string values ["Fall Previous Year", "Before Planting", "Planting", "After Planting / in-crop"]
    incorporation_depth: 0, // a float value must be >= 0
    soil_state: "", // Can be one of the following ["Frozen / Snow Covered","Moist","Dry","Arid","Ideal (At Field Capacity)"]
    fertilizer_mix_id: "", // is a mongo_db ObjectId string that makes reference to another document like a foreign key, and it's required
    application_rate: "",
    rate_unit: "lb/ac",
    has_nitrification_inhibitor: null,
  };
}

function FOUR_R_SOIL_TEST_CREATOR() {
  return {
    nutrient: "", // Can be one of the following ["N", "P", "K", "S", "M", "OM"],
    test: "", // Can take one of the following values: ["Nitrate-N (NO₃-N) Test", "Olsen Test (Bicarbonate Phosphorus Test)", "Ammonium Acetate Extract (Potassium Test)", "Calcium Phosphate Extractable Sulphur Test", "DTPA Micronutrient Test"]
    date: "", // Date string of the form "DD-MM-YYYY"
    result: 0, // can take a float value between [0,100]
    units: "", // Can take one of the following values ["Lbs/Acre", "ppm"]
    frequency: "", // Can take one of the following values ["Yearly", "Every 5 years","Every 4 years","Every 3 years","Every 2 years","Two out of 3 years","Two out of 5 years"]
  };
}

function FOUR_R_ASSESSMENT_CREATOR() {
  return {
    id: "",
    crop_year_id: "",
    soil_tests: [FOUR_R_SOIL_TEST_CREATOR()],
    fertilizer_applications: [FOUR_R_FERTILIZER_APPLICATION_CREATOR()],
    operations_questionnaire: {
      N: {
        Use_A_Nutrient_Balance_Calculator: false, // can be true or false
        Consult_A_CCA_Qualified_Agronomist: false, // can be true or false
        Follow_Provincial_Recommendations: false, // can be true or false
        Use_Variable_Rate_Prescription_Maps: false, // can be true or false
      },
      P: {
        Use_A_Nutrient_Balance_Calculator: false, // can be true or false
        Consult_A_CCA_Qualified_Agronomist: false, // can be true or false
        Follow_Provincial_Recommendations: false, // can be true or false
        Use_Variable_Rate_Prescription_Maps: false, // can be true or false
      },
    },
    assessment_results: {
      rate_nitrogen: {
        result: false,
        successLogs: [],
        errorLogs: [],
      },
      rate_phos: {
        result: false,
        successLogs: [],
        errorLogs: [],
      },
      time_nitrogen: {
        result: false,
        successLogs: [],
        errorLogs: [],
      },
      time_phos: {
        result: false,
        successLogs: [],
        errorLogs: [],
      },
      placement_nitrogen: {
        result: false,
        successLogs: [],
        errorLogs: [],
      },
      placement_phos: {
        result: false,
        successLogs: [],
        errorLogs: [],
      },
    },
  };
}

function FERTILIZER_INGREDIENT_CREATOR() {
  return {
    id: "",
    name: "",
    n_value: 0.0,
    p_value: 0.0,
    k_value: 0.0,
    s_value: 0.0,
  };
}
// function FERTILIZER_MIX_CREATOR(propIngredients = []) {
//   const ingredients = [...propIngredients];

//   const addIngredient = (ingredientId, amountInPounds) => {
//     ingredients.push({
//       ingredientId: "ingredientId",
//       amountInPounds: "amountInPounds",
//     });
//   };

//   const removeIgredient = (idx) => {
//     ingredients.splice(idx, 1);
//   };
//   return ingredients;
// }

const EmptyReportData = [
  [
    "Unique ID",
    "Ecodistrict",
    "Province",
    "Soil Type",
    "Soil Texture",
    "Surface Form",
    "Slope",
    "Year",
    "Crop",
    "Total Nitrogen (kg/ha)",
    "Total Phosphorus (kg/ha)",
    "Total Potassium (kg/ha)",
    "Total Sulfur (kg/ha)",
    "Total Other Fertilizer (kg/ha)",
    "Land Use Efficiency (ha/tonne)",
    "Provincial Land Use Efficiency (ha/tonne)",
    "Land Use Efficiency Index",
    "Energy Use GJ/tonne",
    "Provincial Energy Use (GJ/tonne)",
    "Energy Use Index",
    "GHG Emissions (tCO2/tonne)",
    "Provincial GHG Emissions (tCO2/tonne)",
    "Climate Impact Index",
    "Soil Erosion Risk Mg/ha/yr",
    "Provincial Soil Erosion Risk Mg/ha/yr",
    "Soil Erosion Index",
    "Provincial Soil Loss",
    "Provincial Yield (t/ha)",
    "Provincial Land Use",
    "Provincial Energy Use GJ/tonne crop",
    "Provincial Climate Impact",
    "Provincial Fieldwork Climate Impact (tCO2E/tcrop)",
    "Provincial NonFieldwork Climate Impact (tCO2E/tcrop)",
    "Provincial N-Fertilizer (tCO2e/tcrop)",
    "Provincial Crop Residue (tCO2e/tcrop)",
    "Provincial Leaching (tCO2e/tcrop)",
    "Provincial Volatilization (tCO2e/tcrop)",
    "Total GHG emissions (tCO2e/tcrop)",
    "Column1",
  ],
  [
    "",
    0,
    "",
    "",
    "",
    "",
    "",
    0,
    "",
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    "",
  ],
];

export {
  FARM_CREATOR,
  FIELD_CREATOR,
  CROPYEAR_CREATOR,
  FERTILIZER_OPERATION_CREATOR,
  EmptyReportData,
  FOUR_R_FERTILIZER_APPLICATION_CREATOR,
  FOUR_R_SOIL_TEST_CREATOR,
  FOUR_R_ASSESSMENT_CREATOR,
  // FERTILIZER_MIX_CREATOR,
};
